import { Fragment, memo } from 'react';
import { Button, Flex, SxStyleProp, Text } from 'theme-ui';
import { TransitionType } from 'types/Transitions';
import Icon from 'shared/Icon';

import Tooltip, { placementsList } from '@picsart/rc/old/Tooltip';

import { useTranslator } from '@picsart/rc/services/localization';

export type TransitionCardProps = {
  selected: boolean;
  disabled?: boolean;
  selectHandler: () => void;
  handleRemoveTransition: () => void;
  type: TransitionType;
  name: string;
  isNextSceneEmpty?: boolean;
  isDurationInvalid?: boolean;
};

export type TransitionCardButtonProps = TransitionCardProps & { addTransitionText: string };

const styles: SxStyleProp = { display: 'block', width: '90%', mx: '5%', mt: 3, px: 0, py: 0 };

const Btn = memo(
  ({
    selected,
    disabled,
    selectHandler,
    type,
    name,
    handleRemoveTransition,
    addTransitionText
  }: TransitionCardButtonProps) => (
    <Button
      variant={selected ? 'transitionCardActive' : 'transitionCard'}
      sx={styles}
      disabled={disabled}
      data-test="scene_transition-button"
    >
      <Flex sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
        <Flex
          onClick={selectHandler}
          sx={{
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: 1,
            height: 20,
            py: 1,
            px: 3,
            flex: 1
          }}
        >
          {type === TransitionType.None ? (
            <Fragment>
              <Icon sx={{ pr: 1 }} name="transitions-editor" />
              {addTransitionText}
            </Fragment>
          ) : (
            name
          )}
        </Flex>
        <Text
          onClick={type !== TransitionType.None ? handleRemoveTransition : selectHandler}
          sx={{ fontSize: '150%', fontWeight: 'body', lineHeight: 1, py: 1, px: 3 }}
        >
          {type === TransitionType.None ? '+' : '×'}
        </Text>
      </Flex>
    </Button>
  )
);

export default memo((props: TransitionCardProps) => {
  const { disabled: isDisabled, isDurationInvalid, isNextSceneEmpty } = props;
  const translator = useTranslator();
  const btnProps = {
    ...props,
    disabled: isDisabled || isDurationInvalid || isNextSceneEmpty,
    addTransitionText: translator('Add Transition')
  };
  return isDurationInvalid ? (
    <Tooltip
      placement={placementsList.left}
      content={
        <div sx={{ textAlign: 'left' }}>
          {translator('To_use_transitions,')}
          <br />
          {translator('upload_an_item_that')}
          <br />
          {translator('is_longer_than_1_sec')}
        </div>
      }
    >
      <Btn {...btnProps} />
    </Tooltip>
  ) : (
    <Btn {...btnProps} />
  );
});
